import styles from './AboutUsHome.module.scss';
import Button from '../../common/Button/Button';

import { useNavigate } from 'react-router-dom';
const AboutUs = () => {
  const navigate = useNavigate();

  const aboutDatas = [
    {
      id: 1,
      title: 'Dorośli',
      description: 'Wsparcie i psychoterapia dla dorosłych.',
    },
    {
      id: 2,
      title: 'Dzieci i młodzież',
      description: 'Terapia dostosowana do wieku i potrzeb.',
    },
    {
      id: 3,
      title: 'Zespół',
      description: 'Doświadczeni specjaliści w jednym miejscu.',
    },
    {
      id: 4,
      title: 'Kontakt',
      description: 'Zadzwoń lub napisz – odpowiemy.',
    },
  ];

  return (
    <div className={`${styles.box} ${styles.aboutUs}`}>
      {/* left block: text */}
      <div className={styles.textSection}>
        <h1>O nas</h1>
        <p>
          Jesteśmy zespołem specjalistów, którzy łączą profesjonalizm z empatią.
          Naszym celem jest towarzyszenie w zmianie i wspieranie w trudnościach.
        </p>
        <Button onClick={() => navigate('/aboutUs')}>Dowiedz się więcej</Button>
      </div>

      {/* right block: square */}

      <div className={styles.squaresSection}>
        {aboutDatas.map((aboutData) => (
          <div key={aboutData.id} className={styles.square}>
            <h3>{aboutData.title}</h3>
            <p>{aboutData.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AboutUs;
